import { render, staticRenderFns } from "./_attendance.fields.vue?vue&type=template&id=97d9cc28&scoped=true&"
import script from "./_attendance.fields.vue?vue&type=script&lang=js&"
export * from "./_attendance.fields.vue?vue&type=script&lang=js&"
import style0 from "./_attendance.fields.vue?vue&type=style&index=0&id=97d9cc28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d9cc28",
  null
  
)

export default component.exports